<template>
  <div class="pages">
    <div class="content">
      <el-row class="top">
        <el-col :span="5">
          <div class="utitle">{{ $t("main.personCenter") }}</div>
        </el-col>
        <el-col :span="19"  v-if="isChoosed == 'order'">
          <div class="search">
            <el-input
                :placeholder="$t('main.userCenterSearchPlaceholder')"
                v-model="searchParam"
                @keyup.enter.native="handlegetProduct"
            >
              <template slot="append">
                <div @click="handlegetProduct">{{ $t("main.search") }}</div>
              </template>
            </el-input>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20" class="mt20">
        <el-col :span="5">
          <div class="left">
            <div
                class="leftNav"
                :class="{ active: isChoosed == 'order' }"
                @click="isChoosed = 'order'"
            >
              {{ $t("main.myOrder") }}
            </div>
            <div
                class="leftNav"
                :class="{ active: isChoosed == 'inquiry' }"
                @click="isChoosed = 'inquiry'"
            >
              {{ $t("main.myInquiry") }}
            </div>
            <div
                class="leftNav"
                :class="{ active: isChoosed == 'addr' }"
                @click="isChoosed = 'addr'"
            >
              {{ $t("main.MyAddress") }}
            </div>
            <div
                class="leftNav"
                :class="{ active: isChoosed == 'fp' }"
                @click="isChoosed = 'fp'"
            >
              {{ $t("main.Invoice") }}
            </div>
            <div
                class="leftNav"
                :class="{ active: isChoosed == 'yj' }"
                @click="isChoosed = 'yj'"
            >
              {{ $t("main.feedback") }}
            </div>
            <div class="divider"></div>
            <div
                class="leftNav"
                :class="{ active: isChoosed == 'gr' }"
                @click="isChoosed = 'gr'"
            >
              {{ $t("main.MyProfile") }}
            </div>
            <div
                class="leftNav"
                :class="{ active: isChoosed == 'xg' }"
                @click="isChoosed = 'xg'"
            >
              {{ $t("main.ChangePassword") }}
            </div>
          </div>
        </el-col>
        <el-col :span="19">
          <i-order class="right" ref="order" v-if="isChoosed == 'order'" :searchParam="searchParam"></i-order>
          <i-inquiry class="right" ref="order" v-if="isChoosed == 'inquiry'"></i-inquiry>
          <i-addr class="right" v-if="isChoosed == 'addr'"></i-addr>
          <invoice class="right" v-if="isChoosed == 'fp'" :value=editflag></invoice>
          <after-order class="right" v-if="isChoosed == 'sh'"></after-order>
          <feedback class="right" v-if="isChoosed == 'yj'"></feedback>
          <person-info class="right" v-if="isChoosed == 'gr'"></person-info>
          <update-pwd class="right" v-if="isChoosed == 'xg'"></update-pwd>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import IOrder from "./components/order.vue";
import IInquiry from "./components/inquiry.vue";
import IAddr from "./components/addr.vue";
import Invoice from "./components/invoice.vue";
import Feedback from "./components/feedback.vue";
import PersonInfo from "./components/personInfo.vue";
import UpdatePwd from "./components/updatePwd.vue";
import Cookies from "js-cookie";
export default {
  components: {
    IOrder,
    IInquiry,
    IAddr,
    Invoice,
    Feedback,
    PersonInfo,
    UpdatePwd
  },
  data() {
    return {
      searchParam: "",
      isChoosed: "order",
      orderChoose: -1,
      editflag: false,//对应发票管理的添加和修改状态
      language: ""//判断网站的语言
    };
  },
  watch: {
    "$route.query.nav": {
      immediate: true,
      handler: function(v) {
        // console.log(v);
        if(v) this.isChoosed = v
      }
    }
  },
  mounted() {
    //判断有没有登录
    if(this.$route.query.forgetpsw){
      this.isChoosed = "xg";
    } else if(!Cookies.get("userinfo")) {
        this.$router.push({ path: this.redirect || "/login" });
    }
  },
  methods: {
    // 搜索订单
    handlegetProduct() {
      this.$nextTick(() => {
        this.$refs.order.getOrderList(-1);
        //获取定制
        this.$refs.order.getOrderList(-2)
        this.$refs.order.getOrderList(0);
        this.$refs.order.getOrderList(1);
        this.$refs.order.getOrderList(2);
        this.$refs.order.getOrderList(3);
        this.$refs.order.getOrderList(4);
        this.$refs.order.getOrderList(8);
        this.$refs.order.getOrderList(9);
        //获取全部
        this.$refs.order.getOrderListclick(-1);
      });
    },
  }
};
</script>

<style scoped lang="less">
.pages {
  background-color: #fff;
  .top {
    .utitle {
      font-size: 1.875rem;
      line-height: 3rem;
      font-family: YouSheBiaoTiHei,serif;
      font-weight: 400;
      color: #333333;
      text-align: center;
    }

    .search {
      width: 31.25rem;
      float: right;

      /deep/ .el-input__inner {
        height: 3rem;
        line-height: 3rem;
        border-color: #333;
      }

      /deep/ .el-input-group__append {
        background-color: #333333;
        border: 1px solid #333333;
        color: #fff;
        cursor: pointer;
      }
    }
  }

  .mt20 {
    margin-top: 1.25rem;
  }

  .left {
    min-width: 10rem;
    min-height: 46.25rem;
    background: #f2f2f2;
    border: 1px solid #e5e5e5;
    text-align: center;
    padding: 1.25rem;
    border-radius: 0.5rem;

    .active {
      color: #635796 !important;
      font-weight: bold !important;
    }

    .leftNav {
      padding: 1.25rem;
      font-size: 1.1428rem;
      color: #1a1a1a;
      cursor: pointer;
    }

    .divider {
      margin: 1.25rem 0;
      width: 100%;
      height: 1px;
      background: #ccc;
    }
  }

  .right {
    border-radius: 0.5rem;
  }

  .color-80 {
    color: #808080;
  }
  @media screen and (max-width: 1400px) {
    .content {
      padding: 1.5rem 2% 3.25rem;
    }
  }
  @media screen and (min-width: 1400px) {
    .content {
      padding: 1.5rem 10% 3.25rem;
    }
  }
  @media screen and (min-width: 1700px) {
    .content {
      padding: 1.5rem 15% 3.25rem;
    }
  }
}
</style>
